import { mapGetters } from 'vuex';
import tippy from 'tippy.js';

import { EventBus } from '../event-bus';

export const addToCartButtonMixin = {
  props: {
    product: Object,
  },

  mounted() {
    const ref = this.$refs['add-to-cart-button'];

    if (!ref) {
      return console.warn(
        'Please define a `add-to-cart-button` ref on your trigger to take advantage of the informative tooltip on the button'
      );
    }

    tippy(ref, {
      arrow: true,
      placement: 'bottom',
      content: 'You can only add five items per order',
      onShow: () => this.cartIsFull,
    });
  },

  computed: {
    ...mapGetters('cart', { cartIsFull: 'full' }),

    isAlreadyAdded() {
      const { id, type } = this.product;
      return this.$store.getters['cart/contains']({ id, type });
    },
  },

  methods: {
    addToCart() {
      if (this.isAlreadyAdded || this.cartIsFull) {
        return;
      }

      const { description, price, id, type, url } = this.product;

      this.$store.dispatch('cart/addItem', {
        description,
        price,
        extra: { id, type, url },
      });

      EventBus.$emit('item-added-to-cart');
    },
  },
};
